import {
  Component, HostBinding, Input
} from '@angular/core';
import { EventService } from "../../services/event.service";
import { UserGroupService } from "../../services/user-group.service";
import { PageTitleService } from "../../services/page-title.service";
import { LoginRequired } from "../../decorators/login.required";
import { AuthService } from "../../services/auth.service";
import { User } from "../../app/app.interfaces";

@Component({
	selector: 'mobile-sidebar',
	templateUrl: 'mobile-sidebar.html'
})

@LoginRequired()

export class MobileSidebar{
	
  @HostBinding('class.active') @Input() show: boolean = false;

	constructor(public eventService: EventService,
							public userGroupService: UserGroupService,
							public authService: AuthService)
	{
		
	}


}



// WEBPACK FOOTER //
// ./src/partials/mobile-sidebar/mobile-sidebar.ts